import * as CONTENT_STYLING from 'constants/contentStyling';
import setReadiumProperty from '../setReadiumProperty';

/**
 * Apply readium styles to the document based on current bookAppearanceValuesContext values
 *
 * @method applyStylingConfiguration
 */
const applyStylingConfiguration = (frame, bookAppearanceValuesContext) => {
  // Set non-configurable properties.
  setReadiumProperty(frame, 'view', 'readium-scroll-on');
  setReadiumProperty(frame, 'readium-advanced-on', true);

  // Applies the font family for the content.
  const fontOverride =
    bookAppearanceValuesContext.fontFamily !==
    CONTENT_STYLING.DEFAULTS.FONT_FAMILY
      ? 'readium-font-on'
      : null;
  setReadiumProperty(frame, 'fontOverride', fontOverride);
  setReadiumProperty(
    frame,
    'fontFamily',
    bookAppearanceValuesContext.fontFamily,
  );

  // Applies the font size for the content.
  setReadiumProperty(
    frame,
    'fontSize',
    `${bookAppearanceValuesContext.fontSize * 100}%`,
  );

  // Applies the letter spacing for the content.
  setReadiumProperty(
    frame,
    'letterSpacing',
    `${bookAppearanceValuesContext.letterSpacing}rem`,
  );

  // Applies the line height for the content.
  setReadiumProperty(
    frame,
    'lineHeight',
    bookAppearanceValuesContext.lineHeight,
  );

  // Applies the page margins for the content. Readium margin values are numbers with a default of 1.
  setReadiumProperty(
    frame,
    'pageMargins',
    bookAppearanceValuesContext.pageMargin,
  );

  // Applies a color scheme to the content, such as night mode or sepia.
  if (
    bookAppearanceValuesContext.theme === CONTENT_STYLING.OPTIONS.THEME_DEFAULT
  ) {
    setReadiumProperty(frame, 'appearance', 'readium-day-on');
  }
  if (
    bookAppearanceValuesContext.theme === CONTENT_STYLING.OPTIONS.THEME_SEPIA
  ) {
    setReadiumProperty(frame, 'appearance', 'readium-sepia-on');
  }
  if (
    bookAppearanceValuesContext.theme === CONTENT_STYLING.OPTIONS.THEME_NIGHT
  ) {
    setReadiumProperty(frame, 'appearance', 'readium-night-on');
  }
  if (
    bookAppearanceValuesContext.theme ===
    CONTENT_STYLING.OPTIONS.THEME_HIGH_CONTRAST
  ) {
    setReadiumProperty(frame, 'appearance', 'readium-high-contrast-on');
  }
};

export default applyStylingConfiguration;
